import React, { useEffect } from 'react';
import { withRouter } from 'react-router';
import { Paper } from "@material-ui/core";
import { TechSpecsNav } from '../../elements'
import { Aircraft, Engine, APU, LandingGear, Propeller, EngineModule, AssetInfo } from '../components';
import { trackActivity } from '../../../utils/mixpanel';
import useAssetInfo from '../hooks/useAssetInfo';
import Component from '../components/Component';
const BasicInfo = ({params}) => {
    const { assetInfoData, assetSkeletonLoader: skeletonLoader, refreshAssetInfo } = useAssetInfo(params.type, params.aircraft_slug);
    useEffect(() => {
        if (assetInfoData?.serial_number) {
            trackActivity('Console Management', { page_title: `${params?.type} Technical Specification`, event_type: 'Page Visited', asset_name: assetInfoData?.serial_number, event_desc: 'Visited Technical Specification' });
        }
    }, [assetInfoData?.serial_number]);
    return(
        <section className="asset-tech-specs">
            <AssetInfo assetInfoData={assetInfoData} skeletonLoader={skeletonLoader} getResponseBack={refreshAssetInfo} />
            <Paper elevation={0} className="tech-specs-card console-paper">
                <TechSpecsNav />
                <div className="tech-specs-content">
                    <div>
                        { params.type === 'aircraft' ? <Aircraft skeletonLoader={skeletonLoader} assetInfoData={assetInfoData} getResponseBack={refreshAssetInfo} />:null}
                        { params.type === 'engine' ?<Engine skeletonLoader={skeletonLoader} assetInfoData={assetInfoData} getResponseBack={refreshAssetInfo} /> :null}
                        { params.type === 'apu' ?<APU assetInfoData={assetInfoData} getResponseBack={refreshAssetInfo}/> :null}
                        { params.type === 'lg' ?<LandingGear assetInfoData={assetInfoData} getResponseBack={refreshAssetInfo}/> :null}
                        { params.type === 'propeller' ?<Propeller assetInfoData={assetInfoData} getResponseBack={refreshAssetInfo}/> :null}
                        { ['fan','hpc','hpt','lpt'].includes(params.type) ?<EngineModule assetInfoData={assetInfoData} getResponseBack={refreshAssetInfo} /> :null}
                        {params.type === 'component'?<Component assetInfoData={assetInfoData} getResponseBack={refreshAssetInfo}/>:null}
                    </div>
                </div>
            </Paper>
        </section>
    )
}
export default withRouter(BasicInfo);
